import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

// TODO[job]: add support for other type of file
type MimeType = 'application/pdf';

@Component({
  selector: 'i2g-file-preview',
  templateUrl: 'file-preview.component.html',
  styleUrls: ['file-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilePreviewComponent implements OnChanges {
  @Input() name: string;
  @Input() url: string;
  @Input() mimeType: MimeType;

  @ViewChild('pdfViewer') pdfViewer;

  ngOnChanges(changes: SimpleChanges) {
    if (this.mimeType !== 'application/pdf') {
      return;
    }

    const urlChange =
      changes.url && changes.url.currentValue !== changes.url.previousValue;

    if (urlChange) {
      if (!this.pdfViewer) {
        return;
      }
      // PDF won't get refreshed automatically when the url is changed subsequently, so below is the approach to refresh the PDF
      this.pdfViewer.pdfSrc = this.encodeUrl(this.url);
      this.pdfViewer.refresh();
    }
  }

  encodeUrl(url: string) {
    // URL from S3client contains characters `?` and `&` which breaks the pdfjs viewer
    // Use encodeURI to solve the issue
    return encodeURIComponent(url);
  }
}
